module.exports = __webpack_public_path__ + "mobile/img/img_home_list_banner3.b9c80388.png";